import { render, staticRenderFns } from "./Abacus.vue?vue&type=template&id=f47bb516&scoped=true&lang=pug&"
import script from "./Abacus.vue?vue&type=script&lang=js&"
export * from "./Abacus.vue?vue&type=script&lang=js&"
import style0 from "./Abacus.vue?vue&type=style&index=0&id=f47bb516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47bb516",
  null
  
)

export default component.exports